export { };
Array.prototype.toStringBetweenNewLine = function (this: any[]): string {
    return this.join('\n');
};
Array.prototype.removeDuplicateData = function (this: any[]): any[] {
    return [...new Set(this)];
};
Array.prototype.removeBlankItem = function (this: any[]): any[] {
    return this.filter(n => n);
};